import { State } from ".";
import { User } from "../model/user";
import { LoadState } from "./user";

export const getUser = (state: State): User | null => state.data.user.user;

export const getUserLoadState = (state: State): LoadState =>
    state.data.user.userLoadState;

export const getIsAuthorized = (state: State): boolean =>
    state.data.user.isAuthorized;
